






















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import Exam from '@/components/Exam.vue'

@Component({
  components: { Exam }
})
export default class Home extends Vue {
  public tab: string = '3'
}
